<template>
  <div v-if="defaultBenefits.length > 0" class="c-fa-new-step2 ">
    Perlindungan seperti apa yang Anda cari?
    <div class="c-fa-new-step2-content">
      <i class="fa fa-check"></i> Perlindungan yang paling memenuhi kebutuhan Anda. 
      (Bisa pilih lebih dari satu)
    </div>
    <div class="row pt-3 row-box pb-5" style="margin: auto;">
      <div
        v-for="(benefit, key) in defaultBenefits"
        :key="key"
        class="col-sm-12 col-sm-12-step2"
        style="padding-bottom: 30px; cursor:pointer;" 
        @click="chooseBenefit(benefit.id, benefit.attributes.name )"
      >
        <div
          class="box-life"
          style="padding: 0;"
        >
          <div class="row">
            <div class="col-sm-3 col-sm-3-step2">
              <img alt="banner" :src="benefit.attributes.icon_url"  class="img-responsive">
            </div>
            <div class="col-sm-9  col-sm-9-step2 box-life-title">
              {{ benefit.attributes.name }}
              <p class="box-life-content" style="height: 50px;">
                {{ benefit.attributes.description }}
              </p>
            </div>
          </div>
          <button 
            :class="{
              'no-active': !checkBenefit(benefit.id),
              'button-active': checkBenefit(benefit.id)
            }"
            class="button-step2 button-box"
          >
            <template  v-if=" !checkBenefit(benefit.id)"> 
              Pilih
            </template>
            <img v-if=" checkBenefit(benefit.id)" src="../../../../../assets/images/svg/centang.svg">
          </button>
        </div>
      </div>
    </div>
     <button  class="button-fixed-1 button-continue"
      :disabled="chooseBenefits.length == 0"
      @click="nextStep()">
      LANJUTKAN
    </button>
  </div>
</template>

<script>
const arrayRemove = (arr, value) => arr.filter(ele => ele !== value);

import axios from "axios";

export default {
  name: 'Step2',
  data() {
    return {
      chooseBenefits: [],
      chooseBenefitNames: [],
      defaultBenefits: [],
      env: '',
    }
  },
  props: {
    mBenefits: {
      type: Array,
      default: () => [],
    },
    mBenefitNames: {
      type: Array,
      default: () => [],
    },
    mENV: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.env = this.mENV.env;
    this.getResponseBenefit();
    this.chooseBenefits = this.mBenefits;
    this.chooseBenefitNames = this.mBenefitNames;
  },
  methods: {
    getResponseBenefit() {
      axios.get(`${this.env}/api/fa/benefits`, {}).then(({ data }) => {
        this.defaultBenefits = data.data
      });
    },
    checkBenefit(key) {
      let exist =  this.chooseBenefits.find(benefit => Number(benefit) === Number(key));
      if (exist == undefined) {
        return false;
      }
      return true;
    },
    chooseBenefit(key, name) {
      if (this.checkBenefit(key) == false) {
        this.chooseBenefits.push(Number(key));
        this.chooseBenefitNames.push(name)
      } else {
        this.chooseBenefits = arrayRemove(this.chooseBenefits , Number(key)) || [];
        this.chooseBenefitNames = arrayRemove(this.chooseBenefitNames , name) || [];
      }
    },
    nextStep() {
      this.$emit('submit:benefits', this.chooseBenefits);
      this.$emit('submit:benefit-names', this.chooseBenefitNames);
    }
  }
};
</script>